import React, { useEffect, useState } from 'react';
import { Image, FlatList, ActivityIndicator } from "react-native";
import type { BEEventProps, CompanyProps } from '../../types';
import {LinearGradient} from 'expo-linear-gradient';
import { Icons } from '../../Components';
import { view_styles } from '../../constants/styles';
import CompanyCard from './CompanyCard';
import SearchBox from '../../Components/SearchBox';
import { EngageApi } from '../api';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type EngageHeaderProps = {
    companies:CompanyProps[],
    width:number,
    view_mode?:'desktop'|'mobile',
    onEvent?:(be_event:BEEventProps) => void,
    onSelectCompany?:(company:CompanyProps) => void,
    onManage?:() => void
}

const EngageHeader = ({ companies, width, view_mode, onManage, onEvent, onSelectCompany }:EngageHeaderProps) => {
    const [ active_company, setActiveComany ] = useState<number>(0);
    const [ search, setSearch ] = useState<{
        loading:boolean,
        active: boolean,
        value: string,
        offset: number
    }>({
        loading:false,
        active: false,
        value: 'a',
        offset:0
    });
    const [ found_companies, setFoundCompanies ] = useState<CompanyProps[]>([]);
    const { active, loading, value } = search;
    const Colors = useColors();
    let filtered_companies = [ ...found_companies ]
    filtered_companies = filtered_companies.filter(c => c.company_name.toLowerCase().includes(value.toLowerCase()))

    useEffect(() => {
        getCompaniesFromServer(0);
    },[])

    useEffect(() => {
        if(companies.length == 0){ return }
        setActiveComany(0)
    },[companies.length])

    useEffect(() => {
        if(companies.length == 0){ return }
        let next_company_index = active_company + 1
        let next_company = companies[next_company_index]
        if(!next_company){ next_company_index = 0 }
        setTimeout(() => {
            setActiveComany(next_company_index)
        }, 3000);
    },[active_company])

    const getCompaniesFromServer = async(offset:number) => {
        const cpnys = await EngageApi.searchCompanies(value, offset);
        setSearch({ ...search, loading: false, offset })
        setFoundCompanies(cpnys);
    }

    const renderCompanies = (data:{ item:CompanyProps, index:number }) => {
        return (
            <View transparent style={{ margin:4, marginRight:12 }}>
                <CompanyCard
                    company={data.item}
                    width={width / 2.5}
                    onEvent={onEvent}
                    onSelectCompany={onSelectCompany}
                />
            </View>
        )
    }

    const company = companies[active_company]

    return (
        <View type = 'header'>
            <LinearGradient colors={[Colors.views.background, Colors.views.header ]} style={{ padding:20, flexDirection:'row', alignItems:'center' }}>
                <View float style={{ borderRadius:100,  width:view_mode == 'desktop' ? 75: 50, height:view_mode == 'desktop' ? 75: 50, justifyContent:'center', alignItems:'center', ...view_styles.float }}>
                    {company ?
                    <Image
                        source={{ uri: company.company_image?.url }}
                        style={{ height:view_mode=='desktop'?50:30, width:view_mode=='desktop'?50:30 }}
                        resizeMode='cover'
                    />
                    :<></>}
                </View>
                <View transparent style={{ flex:1, marginLeft:20 }}>
                    <Text theme='h1' color={Colors.text.h1}>Engage with our partners</Text>
                    <Text style={{ marginTop:5 }} size={14} theme='description'>Competitions, squares, brackets are all brought to you without fees thanks to our amazing partners.</Text>
                </View>
                {onManage && view_mode == 'desktop' ?
                    <Button
                        title='Manage'
                        type='success'
                        onPress={() => onManage()}
                    />
                :<></>}
            </LinearGradient>
            <View transparent style={{ padding:10 }}>
                <Button float style={{ flexDirection:'row', alignItems:'center', marginBottom:10 }} onPress={() => setSearch({ ...search, active: !active })}>
                    <View transparent style={{ flex:1, marginRight:10 }}>
                        <Text theme='h1'>{active?'Search':'Support'} Our Partners!</Text>
                        {active ?
                        <Text style={{ marginTop:3 }} theme='description'>Use the search box below to find a brand that you're interested in!</Text>
                        :
                        <Text style={{ marginTop:3 }} theme='description'>Below are brands that currently have availble competitions!</Text>
                        }
                    </View>
                    <View transparent float style={{ height:30, width:30, backgroundColor:Colors.views.header, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                        {active ?
                        <Icons.CloseIcon color={Colors.text.error} size={12} />
                        :
                        <Icons.SearchIcon color={Colors.text.h1} size={16} />
                        }
                    </View>
                </Button>
                {active ?
                <View transparent>
                    <View transparent style={{ marginBottom:10 }}>
                        <SearchBox
                            placeholder='Search our brands'
                            onChange={(text) => setSearch({ ...search, value: text })}
                            onSearch={() => getCompaniesFromServer(0)}
                        />
                    </View>
                    {loading ?
                    <ActivityIndicator size='large' color={Colors.text.h1} />
                    :<></>}
                    <FlatList
                        data={filtered_companies}
                        renderItem={renderCompanies}
                        horizontal
                        keyExtractor={(item) => item.company_id.toString()}
                    />
                </View>
                :
                <FlatList
                    data={companies}
                    renderItem={renderCompanies}
                    horizontal
                    keyExtractor={(item) => item.company_id}
                />
                }
            </View>
        </View>
    )
}

export default EngageHeader